import { Helmet } from 'react-helmet'

import { Cap } from '../../primitives'
import { PrototypeFrame } from '../../PrototypeFrame'
import { AiForwardOptionSection } from './AiForwardOptionSection'
import { CaiMvpPositioningSection } from './CaiMvpPositioningSection'
import { FleetAssistantOptionSection } from './FleetAssistantOptionSection'
import { IdeasOptionSection } from './IdeasOptionSection'
import { MuseOptionSection } from './MuseOptionSection'
import { MvpSection } from './MvpSection'
import { OnlyCaiActiveSection } from './OnlyCaiActiveSection'
import { PlainCaiOptionSection } from './PlainCaiOptionSection'
import { ProductOnboardingSection } from './ProductOnboardingSection'

const SHELL_HEIGHT = 620
const SHELL_CLASS = 'h-[620px] rounded-sm'

const BRIEF = (
  <div className="border-ink-700 grid grid-cols-1 gap-6 border-t pt-6 sm:grid-cols-2 lg:grid-cols-5">
    <div>
      <Cap onDark>Goal</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Lift Ask Cai sessions per active account &mdash; not whether a customer finds the agent once, but
        whether it becomes the way they use Cai. Today the agent is a composer sitting inside three pages, so
        a customer only meets it if they happen to land on one. Pull the live baseline from PostHog before
        this ships.
      </p>
    </div>

    <div>
      <Cap onDark>Project: AI positioning</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Where the agent lives in the account chrome. Every product in{' '}
        <a
          href="https://cailabsinc.slack.com/archives/C0BHE8N8WMP"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand-300 hover:text-brand-200 underline underline-offset-2"
        >
          #product-inspo
        </a>{' '}
        has moved it out of the page and into the frame. Cai has not, and the placement decides how often it
        gets used.
      </p>
    </div>

    <div>
      <Cap onDark>What is real</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Every option is drawn on a prototype fork of the production chrome: same sidebar, top nav and nav
        rows, none of the wiring, page content greeked so the eye stays on the frame rather than the
        dashboard.
      </p>
    </div>

    <div>
      <Cap onDark>Feedback</Cap>
      <ul className="text-ink-200 mt-2 flex flex-col gap-1 text-xs leading-relaxed">
        <li>
          Slack channel:{' '}
          <a
            href="https://cailabsinc.slack.com/archives/C0BHE8N8WMP"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-300 hover:text-brand-200 underline underline-offset-2"
          >
            #product-inspo
          </a>
        </li>
      </ul>
    </div>

    <div>
      <Cap onDark>Next</Cap>
      <p className="text-ink-200 mt-2 text-xs leading-relaxed">
        Draw Option 1, and the options after it, against this same shell so the placements stay comparable.
        The channel already holds the field research they come from &mdash; Slack, PostHog, Gemini, Linear,
        HubSpot and Muse.
      </p>
    </div>
  </div>
)

export function AiPositioningPrototypePage() {
  return (
    <PrototypeFrame
      title="AI positioning V1.0"
      owner="Carrie Phillips"
      date="September 30, 2026"
      status="Front-end prototype"
      brief={BRIEF}
    >
      <Helmet>
        <title>Prototype: AI positioning V1.0</title>
      </Helmet>

      <div className="flex flex-col gap-14">
        <OnlyCaiActiveSection shellClass={SHELL_CLASS} />

        <CaiMvpPositioningSection shellClass={SHELL_CLASS} />

        <PlainCaiOptionSection shellClass={SHELL_CLASS} shellHeight={SHELL_HEIGHT} />

        <ProductOnboardingSection shellClass={SHELL_CLASS} />

        <MvpSection shellClass={SHELL_CLASS} />

        <IdeasOptionSection shellHeight={SHELL_HEIGHT} />

        <FleetAssistantOptionSection shellClass={SHELL_CLASS} shellHeight={SHELL_HEIGHT} />

        <AiForwardOptionSection shellClass={SHELL_CLASS} shellHeight={SHELL_HEIGHT} />

        <MuseOptionSection shellClass={SHELL_CLASS} shellHeight={SHELL_HEIGHT} />
      </div>
    </PrototypeFrame>
  )
}
